
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySnowColour as ObiHeavySnowColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-snow-colour.js';
 
 
 

 
 export const ObiHeavySnowColour = createComponent({
   react: React,
   tagName: 'obi-heavy-snow-colour',
   elementClass: ObiHeavySnowColourElement,
   events: {
     
   }
  });
 
 